export default "__VITE_ASSET__B$_6r314__"